import { render, staticRenderFns } from "./shibaiyuanyin.vue?vue&type=template&id=37cfbf66&scoped=true"
import script from "./shibaiyuanyin.vue?vue&type=script&lang=js"
export * from "./shibaiyuanyin.vue?vue&type=script&lang=js"
import style0 from "./shibaiyuanyin.vue?vue&type=style&index=0&id=37cfbf66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cfbf66",
  null
  
)

export default component.exports